
import template             from "./bFlexitimeTimeTable.html";
import { roundTimeSeconds } from "theme/utils/helpers";
import moment               from 'moment-timezone';
import { createPopper } from '@popperjs/core';

const HALF_HOUR_HEIGHT_IN_PIXELS_LARGE = 40;
const HALF_HOUR_HEIGHT_IN_PIXELS_MEDIUM = 70;

const WEEKDAYS_I18N_CODES = {
  1 : "MONDAY",
  2 : "TUESDAY",
  3 : "WEDNESDAY",
  4 : "THURSDAY",
  5 : "FRIDAY",
  6 : "SATURDAY",
  7 : "SUNDAY",
  0 : "SUNDAY"
};

function sequence(number) {
  return Array
    .apply(null, {length: number})
    .map(Function.call, Number);
}

const HOURS = sequence(24*2).map((x) => {
  return x / 2;
}).map((x) => {
  var rest = (x % 1);
  var hour = x - rest;
  return hour.toString() + (rest > 0.1 ? ":30" : ":00");
});


export function bFlexitimeTimeTableDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: bFlexitimeTimeTableController,
    controllerAs: 'bFlexitimeTimeTable',
    bindToController: true,
    scope: {
      workspace: "=",
      summary: "=",
      teamLeaderVersion: "=",
      selectedUser: "=",
      invoiceDetailsFeatureFlag: "=",
      worklogClients: "=",
      groupNameClients: "=",
      showInterruptions: "=",
      showProcesses: "=",
      showAccepted: "=",
      showToAccept: "=",
      touched: "=",
      showAcceptAll: "=",
      allowedProjects: "=",
      setupWorklogSource: "&",
      outputTypeFeatureFlag: "=",
      overtimeApplicationsFlag: "=",
      billingTypes: "=?",
      user: "=?"
    }
  };

  return directive;
}

class bFlexitimeTimeTableController {
  constructor ($rootScope, $scope, $translate, $window, bModal, Stats, OvertimeApplications) {
    'ngInject';

    window.FLEXITable = this;

    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$translate = $translate;
    this.$window = $window;
    this.bModal = bModal;
    this.Stats = Stats;
    this.OvertimeApplications = OvertimeApplications;

    this.jobStatuses = {
      STARTED: this.$translate.instant("FLEXITIME.STATUSES.STARTED"),
      FINISHED: this.$translate.instant("FLEXITIME.STATUSES.FINISHED"),
      ERROR: this.$translate.instant("FLEXITIME.STATUSES.ERROR"),
    };
    this.saveClicked = false;

    this.init();

    this.$scope.$on("$locationChangeStart", (event) => {
      const message = this.$translate.instant("FLEXITIME.UNSAVED_WARNING");
      if(this.anyUnsavedChanges() && !confirm(message)) {
        event.preventDefault(message);
      }
    });
  }

  init() {
    this.weekdays = WEEKDAYS_I18N_CODES;

    this.modal = null;

    this.editedWorklogId = 0;
    this.worklogsToSave = {};
    this.worklogsToDelete = {};
    this.newWorklogs = [];
    this.today = moment();

    this.touched = false;

    this.$scope.$watch(() => this.workspace, newValue => this.updateHiddenClients(newValue), true);
    this.$scope.$watch(() => this.workspace.clientGroupNames, newValue => this.updateHiddenClientsGroup(newValue), true);

    this.$scope.$watch(() => this.summary, newValue => this.updateComputedValues(newValue, this.selectedUser, this.worklogsToSave, this.newWorklogs, this.worklogsToDelete), true);

    this.$scope.$watch(() => this.workspace, () => this.updateComputedValues(this.summary, this.selectedUser, this.worklogsToSave, this.newWorklogs, this.worklogsToDelete), true);
    this.$scope.$watch(() => this.selectedUser, newValue => this.updateComputedValues(this.summary, newValue, this.worklogsToSave, this.newWorklogs, this.worklogsToDelete), true);
    this.$scope.$watch(() => this.worklogsToSave, newValue =>   this.updateComputedValues(this.summary, this.selectedUser, newValue, this.newWorklogs, this.worklogsToDelete), true);
    this.$scope.$watch(() => this.worklogsToDelete, newValue => this.updateComputedValues(this.summary, this.selectedUser, this.worklogsToSave, this.newWorklogs, newValue), true);
    this.$scope.$watch(() => this.newWorklogs, newValue =>      this.updateComputedValues(this.summary, this.selectedUser, this.worklogsToSave, newValue, this.worklogsToDelete), true);
    this.$scope.$watch(() => this.allowedProjects, newValue =>      this.updateAllowedProjects(newValue), true);

    this.$scope.$on("addNewWorklog", () => { this.addNewWorklog(); });
    this.$scope.$on("acceptAllWorklogs", () => { this.acceptAllWorklogs(); });
    this.$scope.$on("saveWorklogs", () => { this.toggleSaveDialog(); });
  }

  hourHeightInPixels(halfSize) {
    return halfSize * 2;
  }

  updateAllowedProjects(newVal) {
    this.allowedProjects = newVal;
  }

  isFuture(day, hour) {

    const date = moment(day.date.format('YYYY-MM-DD') + hour, 'YYYY-MM-DD hh:mm');
    return date.isAfter(moment());
  }

  worknormForDay(day) {
    const isWorkTimeThere = day.workdayTime;

    const workTime = isWorkTimeThere && moment.duration(day.workdayTime.workTime).asMinutes() || 0;
    const workNorm = isWorkTimeThere && moment.duration(day.workdayTime.expectedWorknorm.worknorm).asMinutes() || 0;

    const workNormPercentage = !isWorkTimeThere ? 100 : (workNorm == 0 ? 100 : (workTime / workNorm * 100));
    return workNormPercentage.toFixed(0);
  }

  hasWorknorm(day) {
    const isWorkTimeThere = !!day.workdayTime;
    return isWorkTimeThere && moment.duration(day.workdayTime.expectedWorknorm.worknorm).asMinutes() > 0;
  }

  dayWorkTime(day) {
    const isWorkTimeThere = !!day.workdayTime;
    return isWorkTimeThere && moment.duration(day.workdayTime.workTime).asMinutes() || 0;
  }

  worklogPosition(worklog) {
    const width = angular.element(this.$window)[0].innerWidth;
    const halfSize = width > 1199 ? HALF_HOUR_HEIGHT_IN_PIXELS_LARGE : HALF_HOUR_HEIGHT_IN_PIXELS_MEDIUM;

    const firstHourIndex = this.hours && this.hours[0] && HOURS.indexOf(this.hours[0]) || 0;

    const offset = - firstHourIndex * halfSize;
    const hourOffset = worklog.startedAtTime.hour() * halfSize * 2;
    const minuteOffset = worklog.startedAtTime.minute() / 60 * (halfSize * 2);

    const durationHeight = (worklog.duration.asMinutes() / 60 * this.hourHeightInPixels(halfSize));

    const top = hourOffset + minuteOffset + offset + 'px';
    const height = Math.max(halfSize, durationHeight) + "px";
    const maxHeight = height;
    return { top, height, maxHeight };
  }

  updateHiddenClients(workspace) {
    if(workspace) {
      this.$rootScope.hiddenClients = this.workspace.clients
        .filter((x) => !x.show)
        .map((x) => x.id)
        .reduce((x, y) => {x[y] = true; return x;}, {});
    }
  }

  updateHiddenClientsGroup(workspace) {
    if(workspace) {
      this.$rootScope.hiddenClientsGroup = this.workspace.clientGroupNames
        .filter((x) => !x.show)
        .map((x) => x.id)
        .reduce((x, y) => {x[y] = true; return x;}, {});
    }
  }

  updateComputedValues(summary, selectedUser, worklogsToSave, newWorklogs, worklogsToDelete) {
    setTimeout(() => this.$scope.$apply(), 10);
    if(selectedUser && this.workspace) {
      this.currentUser = summary.users.find((x) => x.id == selectedUser);

      this.currentUser.worklogs.map(worklog => {
        const client = this.workspace.clients.find(client => client.id === worklog.clientId);
        if (client && client.additionalInfo)
          worklog.clientNameWithAdditionalInfo = `(${client.additionalInfo}) ${worklog.clientName}`;
      });

      setTimeout(() => this.$scope.$apply(), 10);

      var startGridTime = 800;
      let minWorklogTime = Infinity;

      this.worklogsToDeleteList = Object.values(this.worklogsToDelete);
      this.worklogsToSaveList = Object.values(this.worklogsToSave);

      this.worklogsByDate = summary.dates.map((day, index) => {
        const workdayTime = this.currentUser
          .overtimeSummary
          .workdayTimes
          .find((x) => {
            return moment(x.date).isSame(day.date);
          });

        const overWriteWithNewWorklogVersions = (worklog) => {
          return worklogsToSave[worklog.id] || worklog;
        };

        const overWriteWithDeleted = (worklog) => {
          return worklogsToDelete[worklog.id] || worklog;
        };

        const isSameDay = (worklog) => {
          return worklog.startedAtTime.isSame(day.date, "day");
        };

        const checkEarliest = (x) => {
          const time = parseInt(x.startedAtTime.format("HHmm"));
          if(time < minWorklogTime) minWorklogTime = time;
          return x;
        };

        const worklogs = this.currentUser
          .worklogs
          .concat(newWorklogs)
          .map(overWriteWithNewWorklogVersions)
          .map(overWriteWithDeleted)
          .map(checkEarliest)
          .filter(isSameDay);

        if( this.newWorklogs.length >0
            || Object.keys(this.worklogsToSave).length > 0
            || Object.keys(this.worklogsToDelete).length > 0
        ) {
          this.touched = true;
        } else {
          this.touched = false;
        }

        this.showAcceptAll = !this.currentUser.allAccepted || !newWorklogs.every(w => w.approved);

        return {
          index,
          ...day,
          workdayTime,
          worklogs
        };
      });
      if(minWorklogTime != Infinity) {
        startGridTime = minWorklogTime;
      }

      this.hours = HOURS.filter((x) => {
        return parseInt(x.replace(":", "")) >= (startGridTime - 100);
      });

      this.worklogClients = this.worklogsByDate.map((x) => x.worklogs).flat().map((x) => x.clientId).filter((x) => x).uniq();
    }
  }

  openWorklog(worklog) {
    this.editedWorklogId = worklog.id;
    worklog.hasOvertimeApplicationInfo = false;
    worklog.applications = [];
    worklog.oldDuration = angular.copy(worklog.duration);
    worklog.oldOvertimeApplicationId = angular.copy(worklog.overtimeApplicationId);

    if (this.overtimeApplicationsFlag)
      this.OvertimeApplications.getPossibleApplicationsForUser(
        this.selectedUser,
        worklog.clientId,
        worklog.startedAtTime.format("YYYY-MM-DD")
      ).then(
        (success) => {
          worklog.hasOvertimeApplicationInfo = true;
          worklog.applications = success.data.filter(application => (
            application.duration !== application.reportedDuration
            || application.id === worklog.overtimeApplicationId
          ));
          this.createPopper(worklog);
        }
      );
    else
      this.createPopper(worklog);
  }

  createPopper(worklog) {

    setTimeout(function () {
      (createModalPopper(worklog));
    }, 0);

    function createModalPopper(worklog) {

      const modal = (worklog.id === "new") ?
        document.querySelector('#modal_new') :
        document.querySelector('#modal_' + worklog.id.replace(/[.]/g, '\\$&'));
      const referenceModal = (worklog.id === "new") ?
        document.querySelector('#reference_new') :
        document.querySelector('#reference_' + worklog.id.replace(/[.]/g, '\\$&'));

      createPopper(referenceModal, modal, {
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 20],
            },
          },
        ],
        placement: 'right',
      });

      if (modal && modal.style)
        modal.style.display = "block";
    }
  }

  showWorkLogHelper(id, finishedAtTime) {
    const workLogHelper = document.getElementById(id + '_article');
    if(moment(finishedAtTime).format('HH') > 19){
      const offsetHeight = workLogHelper.parentElement.getClientRects()[0].height;
      const workLogHeight = workLogHelper.parentElement.parentElement.getClientRects()[0].height;
      if(offsetHeight > 0 && workLogHeight < offsetHeight) {
        workLogHelper.style.marginTop = "-" + offsetHeight + "px";
      }
    }
  }

  closeWorkLogHelper(id){
    const workLogHelper = document.getElementById(id + '_article');
    const offsetHeight = workLogHelper.parentElement.getClientRects()[0].height;
    if(offsetHeight == 0) {
      workLogHelper.style.marginTop = "0px";
    }
  }

  preHandleNewVersionOfWorklog(worklog) {
    if (!worklog.overtimeApplicationId)
      return this.handleNewVersionOfWorklog(worklog);

    const application = worklog.applications.find(application => application.id === worklog.overtimeApplicationId);
    let splitIsNeeded;

    if (application) {
      const leftDuration = moment.duration(application.duration)
        .subtract(moment.duration(application.reportedDuration))
        .add(worklog.oldOvertimeApplicationId === application.id ? moment.duration(worklog.oldDurationText) : 0);
      const durationChange = (!worklog.oldDuration || worklog.new || worklog.duration.asMilliseconds() === worklog.oldDuration.asMilliseconds())
        ? worklog.duration
        : moment.duration(worklog.oldDuration).subtract(worklog.duration);
      splitIsNeeded = moment.duration(leftDuration).subtract(durationChange.asMilliseconds()) < 0;
    }

    if (splitIsNeeded) {
      this.splitModal = true;
      this.splitModalData = {
        worklog: worklog
      };
    } else {
      worklog.splitOvertimeApplicationWorklog = false;
      this.handleNewVersionOfWorklog(worklog);
    }
  }

  handleNewVersionOfWorklogWithSplit() {
    const worklog = angular.copy(this.splitModalData.worklog);
    worklog.splitOvertimeApplicationWorklog = true;

    this.handleNewVersionOfWorklog(worklog);
    this.splitModalData = null;
    this.splitModal = null;
  }

  handleNewVersionOfWorklog(newVersionOfWorklog) {
    if(newVersionOfWorklog.id == 'new') {
      newVersionOfWorklog.id = Math.random().toString();
      newVersionOfWorklog.edited = true;
      this.newWorklogs.push(newVersionOfWorklog);
    }
    else {
      if(newVersionOfWorklog.new) {
        this.newWorklogs = this.newWorklogs.map((worklog) => {
          const isSame = worklog.id == newVersionOfWorklog.id;
          return isSame ? newVersionOfWorklog : worklog;
        });
      } else {
        this.worklogsToSave[newVersionOfWorklog.id] = {
          ...newVersionOfWorklog,
          edited: true
        };
      }
    }
    this.closeWorklog();
  }

  handleDeleteWorklog(worklogToDelete) {
    if(worklogToDelete.new) {
      this.newWorklogs = this.newWorklogs.filter((x) => x.id != worklogToDelete.id);
    } else {
      this.worklogsToDelete[worklogToDelete.id] = {
        ...worklogToDelete,
        deleted: true
      };
    }
    this.closeWorklog();
  }

  closeWorklog() {
    this.editedWorklogId = 0;
    this.newWorklogs = this.newWorklogs.filter((x) => x.id != 'new');
  }

  addNewWorklog(day, hour, type) {
    const pickedDay = day || this.worklogsByDate[0].date;
    const pickedHour = hour || "8:00";
    const pickedType = type || "process";

    const startStr = pickedDay.format("YYYY-MM-DD")  + " " + pickedHour;
    const nextHour = this.hours[this.hours.indexOf(pickedHour) + 1];

    const endStr = (typeof nextHour !== 'undefined') ?
      pickedDay.format("YYYY-MM-DD") + " " + nextHour:
      pickedDay.format("YYYY-MM-DD") + " " + '23:59';

    const startedAtTime = moment(startStr);
    const startedAt = startedAtTime.toISOString();
    const finishedAtTime = moment(endStr);
    const finishedAt = finishedAtTime.toISOString();
    const duration = moment.duration(finishedAtTime.diff(startedAtTime));
    const worklog = {
      id: "new",
      new: true,
      type:pickedType,
      startedAtTime,
      startedAt,
      finishedAt,
      finishedAtTime,
      duration,
      userId: this.currentUser.id
    };
    this.newWorklogs.push(worklog);
    this.editedWorklogId = "new";
    this.createPopper(worklog);
    return worklog;
  }

  dropped(dragEl, dropEl) {
    const worklogEl = angular.element(dragEl);
    if (!worklogEl.scope())
      return;

    const hourEl = angular.element(dropEl);

    const worklog = worklogEl.scope().worklog;
    if (worklog.project) {
      worklog.projectId = worklog.project.id;
    }
    const day = hourEl.scope().day;
    const zpadhour = (s) => s.length == 4 ? "0"+s:s;
    const hour = zpadhour(hourEl.scope().hour);

    const dateS = `${day.date.format("YYYY-MM-DD")}T${hour}:00.100000`;
    const date = moment(dateS);
    const finishedAt = date.clone().add(worklog.duration);

    const overlapTheFuture = finishedAt.isAfter(moment());

    if (overlapTheFuture) {
      //TODO - dialog with info "that operation is not possible - worklog overlap the future"
      return;
    }

    // getting processGroup of worklog details
    // const processClientConfigs = this.workspace.processClientConfigurations;
    // const processes = this.workspace.processes;
    // const pgs = this.workspace.processGroups;
    // const process = processClientConfigs.find(pcc => pcc.id == worklog.processClientConfigurationId);
    // const processGroup = processes.find(p => p.id === (process && process.processId));
    // const pgDetails = pgs.find(pg => pg.id == (processGroup && processGroup.processGroupId));

    if (!worklog.new) {
      this.worklogsToSave[worklog.id] = {
        ...worklog,
        // pg: pgDetails,
        startedAtTime: date,
        startedAt: date.toISOString(),
        finishedAtTime: finishedAt,
        finishedAt: finishedAt.toISOString(),
        edited: true
      };
    } else {
      this.newWorklogs = this.newWorklogs.map(w => {
        if (w.id !== worklog.id) {
          return w;
        } else {
          return {
            ...w,
            startedAtTime: date,
            startedAt: date.toISOString(),
            finishedAtTime: finishedAt,
            finishedAt: finishedAt.toISOString(),
          };
        }
      });
    }

    setTimeout(() => this.$scope.$apply(), 10);
  }

  acceptAllWorklogs() {
    this.worklogsByDate
      .map((x) => x.worklogs)
      .flat()
      .filter((x) => !x.approved)
      .map((worklog) => {
        const approvedWorklog = {
          ...worklog,
          approved: true
        };
        this.handleNewVersionOfWorklog(approvedWorklog);
      });
    this.toggleSaveDialog();
  }

  toggleSaveDialog() {
    this.dialog = "save";
  }

  abortWarning() {
    this.dialogWarning = true;
  }

  abortHandler() {
    if (this.anyJobFinished) {
      this.$rootScope.$emit("allWorklogsJobsFinished");
    }

    this.newWorklogs = [];
    this.worklogsToDelete = {};
    this.worklogsToDeleteList = [];
    this.worklogsToSave = {};
    this.worklogsToSaveList = [];
    this.dialog = null;
    this.dialogWarning = false;
    this.jobsHaveErrors = null;
    this.jobStatus = {};
  }

  anyUnsavedChanges() {
    return Boolean(
      (this.newWorklogs && this.newWorklogs.length > 0) ||
      (this.worklogsToDeleteList && this.worklogsToDeleteList.length) > 0 ||
      (this.worklogsToSaveList && this.worklogsToSaveList.length) > 0
    );
  }

  saveHandler() {
    if (this.saveClicked)
      return;
    
    this.saveClicked = true;

    const deleteJobs = angular.copy(this.worklogsToDeleteList)
    .sort((a,b) => a.startedAtTime - b.startedAtTime)
    .map((x) => {return {delete: true, ...x};});
    const editJobs = angular.copy(this.worklogsToSaveList)
    .sort((a,b) => a.startedAtTime - b.startedAtTime)
    .map((x) => {return {edit: true, ...x};});
    const createJobs = angular.copy(this.newWorklogs)
      .sort((a,b) => a.startedAtTime - b.startedAtTime)
      .map((x) => {return {create: true, ...x};});

    const listOfJobs = deleteJobs.concat(deleteJobs).concat(editJobs).concat(createJobs);

    this.jobStatus = this.jobStatus || {};

    const performJob = (job) => {
      if (job.billingTypeId === "" || (job.type === 'interrupt' && !job.valueAdded))
        delete job.billingTypeId;

      if(job.delete) {
        return this.Stats.declineWorklog(job);
      } else if(job.edit) {
        return this.Stats.safeSaveWorklog(job);
      } else if(job.create) {
        return this.Stats.safeCreateWorklog({
          ...job,
          id: undefined
        });
      }
    };

    const onJobRun = () => {
      const statuses = Object.values(this.jobStatus);
      const finished = statuses.filter((x) => !x.done);
      const allFinished = finished.length == 0;
      const errors = Object.values(this.jobStatus).filter((x) => x.error).length > 0;
      this.jobsAllFinished = allFinished;
      this.anyJobFinished = finished.length !== statuses.length;
      this.jobsHaveErrors = errors;
    };

    const runJob = (job, listOfJobs) => {
      if(job) {
        const thisJob = this.jobStatus[job.id];
        if(thisJob && thisJob.done) {
          onJobRun();
          runJob(listOfJobs[0], listOfJobs.slice(1));
          return Promise.resolve();
        } else {
          this.jobStatus[job.id] = {class:"started", message: this.jobStatuses.STARTED, statusClass: "badge badge-started"};
          return performJob(job).then((success) => {
            this.jobStatus[job.id] = {done: true, class:"done", message: this.jobStatuses.FINISHED, result: success, statusClass: "badge badge-finished"};
            onJobRun();
            runJob(listOfJobs[0], listOfJobs.slice(1));
          }, (error) => {
            this.jobStatus[job.id] = {class:"error", message: this.jobStatuses.ERROR, error, statusClass: "badge badge-error"};
            onJobRun();
            runJob(listOfJobs[0], listOfJobs.slice(1));
          });
        }
      } else 
        Promise.resolve();
    };

    runJob(listOfJobs[0], listOfJobs.slice(1))
      .then(() => this.saveClicked = false);
  }

  closeDialog() {
    if(this.jobsAllFinished || this.anyJobFinished) {
      this.$rootScope.$emit("allWorklogsJobsFinished");
    }
    this.dialog = null;
    this.dialogWarning = false;
  }

  copyToClipboard(value) {
    this.closeWorklog();

    this.modalConfig = {
      cancelText: "",
      acceptText: "OK",
      hideLeftButton: "hide"
    };

    this.bModal.show(this.modalConfig).then(() => {
      this.worklogCopied = { ...value, id: 'new' };
      const closeWindowByEsc = (e) => {
        if (!e) e = window.event;
        const keyCode = e.keyCode || e.which;
        if (keyCode == '27') {
          this.worklogCopied = undefined;
          this.$scope.$apply();
          document.removeEventListener('keydown', closeWindowByEsc, false);
        }
      };
      document.addEventListener('keydown',closeWindowByEsc, false);
    }, angular.noop);
  }

  pasteNewWorklog(day, hour) {
    const startStr = day.format("YYYY-MM-DD")  + " " + hour;
    const startedAtTime = moment(startStr).add(10, "millisecond");
    const startedAt = startedAtTime.toISOString();
    const duration = this.worklogCopied.duration;
    const finishedAtTime = moment(startedAtTime).add(duration);
    const finishedAt = finishedAtTime.format();

    const newWorklog = {
      ...this.worklogCopied,
      startedAt,
      startedAtTime,
      duration,
      finishedAtTime,
      finishedAt
    };

    this.handleNewVersionOfWorklog(newWorklog);
    this.worklogCopied = undefined;
  }

  formatDuration(d) {
    const zeroTrim = (x) => ('0'+x).slice(-2);
    const iso = d.toJSON();
    const rounded = roundTimeSeconds(iso);
    const duration = moment.duration(rounded);
    const hours = zeroTrim(duration.hours());
    const minutes = zeroTrim(duration.minutes());

    return `${hours}:${minutes}`;
  }
}
